import request from 'api/requestUtils'
import { paths } from '@luxuryescapes/contract-cart'
import { mapMultiCartOfferComparisonItem } from './multiCartMappers'
import type { MachineContext } from 'typings/app/machineContext'

type GetResponse = paths['/api/carts/cart-offer-comparison/multi-carts']['get']['responses']['200']['content']['application/json']

export async function getMultiCartOfferComparison(): Promise<MachineContext.CartActiveComparisons> {
  const response = await request.get<GetResponse>(
    '/api/carts/cart-offer-comparison/multi-carts',
    { credentials: 'include' },
  )

  return response.result?.reduce((acc: MachineContext.CartActiveComparisons, comparison) => {
    // API returns comparisons ordered by createdAt DESC, so we only set if not already present to keep the newest
    if (comparison.cartId && !acc[comparison.cartId]) {
      acc[comparison.cartId] = comparison.items?.map(mapMultiCartOfferComparisonItem) ?? []
    }
    return acc
  }, {}) ?? {}
}
